/* 
    Fires a blank 'view_cart_manual' event for the custom pixel.
    Needed because Shopify doesn't trigger the `cart_viewed` event for sidecart openings.
*/
document.addEventListener('DOMContentLoaded', function(){
    const sidecart = document.querySelector('.cart-drawer-button');

    if(!!sidecart){
        const observer = new MutationObserver(() => {
        if(sidecart.getAttribute('aria-expanded') === 'true'){
            fireManualViewCart();
        }
        });

        observer.observe(sidecart, { attributes: true });
    }
});

function fireManualViewCart(){
    Shopify.analytics.publish('view_cart_manual', {});
}